import { AssetFolder, AssetOwnerCategory } from '../models/Asset';

import AssetService from '../services/AssetService';
import AuthService from '../services/AuthService';
import Config from '../config';
import HttpClient from '../services/HttpClient';

interface VideoEncodeRequest {
  tenant: string;
  owner: number;
  assetkey: string;
  category: AssetOwnerCategory;
}

export function useVideoEncoder(tenant: string) {
  function requestEncoding(
    owner: number,
    assetkey: string,
    category: AssetOwnerCategory
  ) {
    const token = AuthService.getAccessToken();
    const requestParams: VideoEncodeRequest = {
      tenant,
      owner,
      assetkey,
      category
    };

    HttpClient.post(`${Config.ASSET_DS}/api/encode`, requestParams, {
      authorization: `Bearer ${token}`
    });
  }

  return {
    requestEncoding
  };
}
